var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',{staticClass:"sub-navigation-list"},_vm._l((_vm.items),function(item,index){return _c('v-list-item',{key:index,attrs:{"to":item.globalTo || (item.to && `${_vm.to}/${item.to}`),"href":item.href,"target":item.globalTo || item.to ? '_self' : '_blank'}},[_vm._v(_vm._s(_vm.$t(item.text)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }